import monitoringService from '../services/monitoringService';
import { clearDraftsForLogout } from '../app/adform/utils/draftStorage';
import { chatCache } from '../app/profile/utils/chatCache';

// Құрылғы баптауы, аккаунтқа тиесілі емес — шыққаннан кейін локация модалы қайта шықпауы керек
const KEEP_ON_LOGOUT = ['vipSelectedLocation', 'locationConfirmed'];

// Барлық «Шығу» батырмалары осыны шақырады: userLogout оқиғасы (socket, тариф контексті)
// localStorage тазаланбай тұрып жіберілуі керек — тыңдаушылар әлі токенді көреді.
export const logout = async () => {
    await monitoringService.trackLogout().catch(() => {});
    window.dispatchEvent(new Event('userLogout'));
    const keep = KEEP_ON_LOGOUT.map((k) => [k, localStorage.getItem(k)]);
    clearDraftsForLogout();
    keep.forEach(([k, v]) => { if (v !== null) localStorage.setItem(k, v); });
    // clearDraftsForLogout бұны да өшіреді, бірақ оған сүйенбейміз — ортақ
    // компьютерде келесі адам бұрынғы пайдаланушының чаттарын көрмеуі керек.
    chatCache.clearAll();
};
